// App.js
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';

import Header from './components/Header';
import Sidebar from './components/Sidebar';
import AdminLogin from './components/AdminLogin';
import AdminRegister from './components/AdminRegister';
import AdminForgotPassword from './components/AdminForgotPassword';
import DefaultDashboard from './components/DefaultDashboard';
import ProfileView from './pages/ProfileView';
import ManageCategory from './pages/ManageCategory';
import ManageVendor from './pages/ManageVendor';
import CreateVendor from './pages/CreateVendor';
import UpdateVendor from './pages/UpdateVendor';
import ManagePackage from './pages/ManagePackage';
import CreatePackage from './pages/CreatePackage';
import UpdatePackage from './pages/UpdatePackage';
import ManagePage from './pages/ManagePage';
import ManageSubPage from './pages/ManageSubPage';
import CreateSubPage from './pages/CreateSubPage';
import UpdateSubPage from './pages/UpdateSubPage';
import ManageLocation from './pages/ManageLocation';
import CreateLocation from './pages/CreateLocation';
import UpdateLocation from './pages/UpdateLocation';
import ManageItinerary from './pages/ManageItinerary';
import CreateItinerary from './pages/CreateItinerary';
import UpdateItinerary from './pages/UpdateItinerary';
import ManageUser from './pages/ManageUser';
import DisplayPage from './pages/DisplayPage';
import CreateMainPage from './pages/CreateMainPage';
import UpdateMainPage from './pages/UpdateMainPage';
import PackageApproval from './pages/PackageApproval';
import Profile_View from './pages/ProfileView';
import Approval from './pages/approval';
import Upgrade from './pages/Upgrade';
import ExpiredPackage from './pages/ExpiredPackage';

import FiltterPage from './components/FiltterPage';
import TotalUmrahPackages from './components/filterUmrah/TotalUmrahPackages';
import TotalHajjPackages from './components/filterUmrah/TotalHajjPackages';
import LeadDashboard from './components/LeadDashboard';

import useInactivityLogout from './custonHook/useInactivityLogout';

import './App.css';
import ResetPassword from './components/ResetPassword';

function AppContent({ isLoggedIn, handleLogin }) {
  const [showProfile, setShowProfile] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Hide profile when route changes
  useEffect(() => {
    setShowProfile(false);
  }, [location.pathname]);

  // determine when sidebar should be hidden (e.g. upgrade page)
  const hideSidebar = location.pathname === '/upgrade';

  if (!isLoggedIn) {
    return (
      <Routes>
        <Route path="/" element={<AdminLogin onLogin={handleLogin} />} />
        <Route path="/Vendor-register" element={<AdminRegister onLogin={handleLogin} />} />
        <Route path='/forgot-password' element={<AdminForgotPassword/>} />
        <Route path='/reset-password' element={<ResetPassword/>} />
        
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }

  return (
    <div className='app'>
      <div className='app-content'>
        {!hideSidebar && <Sidebar />}
        <main className='main-content'>
          <Header
            handleLogin={handleLogin}
            hideSidebar={hideSidebar}
            onProfileClick={() => {
              // navigate('/dashboard');
              setShowProfile(true);
            }}
          />

          {showProfile ? (
            <ProfileView />
          ) : (
            <Routes>
              <Route path='/dashboard' element={<DefaultDashboard handleLogin={handleLogin} />} />
              <Route path='/manage-user' element={<ManageUser />} />
              <Route path='/approval' element={<Approval/>} />
              <Route path='/profile-view' element={<Profile_View />} />
              <Route path='/manage-vendor' element={<ManageVendor />} />
              <Route path='/create-vendor' element={<CreateVendor />} />
              <Route path='/update-vendor/:id' element={<UpdateVendor />} />
              <Route path='/manage-category' element={<ManageCategory />} />
              <Route path='/manage-package' element={<ManagePackage />} />
              <Route path='/create-package' element={<CreatePackage />} />
              <Route path='/update-package/:id' element={<UpdatePackage />} />
              <Route path='/package-approval' element={<PackageApproval />} />
              <Route path='/expired-packages' element={<ExpiredPackage />} />
              <Route path='/manage-page' element={<ManagePage />} />
              <Route path='/manage-location' element={<ManageLocation />} />
              <Route path='/create-location' element={<CreateLocation />} />
              <Route path='/update-location/:id' element={<UpdateLocation />} />
              <Route path='/manage-itinerary' element={<ManageItinerary />} />
              <Route path='/create-itinerary' element={<CreateItinerary />} />
              <Route path='/update-itinerary/:id' element={<UpdateItinerary />} />
              <Route path='/manage-subpage' element={<ManageSubPage />} />
              <Route path='/create-subpage' element={<CreateSubPage />} />
              <Route path='/update-subpage/:id' element={<UpdateSubPage />} />
              <Route path='/display-pages' element={<DisplayPage />} />
              <Route path='/create-mainpage' element={<CreateMainPage />} />
              <Route path='/update-mainpage/:id' element={<UpdateMainPage />} />
              <Route path='/upgrade' element={<Upgrade />} />
              <Route path='*' element={<Navigate to="/dashboard" />} />
                  <Route path='/packages' element={<FiltterPage/>}/>
                  <Route path='/umrah-packages-list' element={<TotalUmrahPackages/>}/>
                  <Route path='/hajj-packages-list' element={<TotalHajjPackages/>}/>
                  <Route path='/lead-dashboard' element={<LeadDashboard/>}/>
            </Routes>
          )}
        </main>
      </div>
    </div>
  );
}

function App() {
  const admin = JSON.parse(localStorage.getItem('vendor')) || null;
  const [isLoggedIn, setIsLoggedIn] = useState(admin);

  const handleLogin = (data) => {
    setIsLoggedIn(data);
  };

  const handleLogout = () => {
    localStorage.removeItem('vendorId'); 
    localStorage.removeItem('vendor');
    localStorage.removeItem("expiresAt");
    setIsLoggedIn(null);
  };

  useInactivityLogout(isLoggedIn ? handleLogout : () => {}, 5 * 60 * 1000);


  useEffect(() => {

    const interval = setInterval(() => {
    const expiresAt = JSON.parse(localStorage.getItem("expiresAt"));

    // If expiresAt does NOT exist → force logout
    if (!expiresAt) {
      setIsLoggedIn(null);
      localStorage.removeItem("admin");
      return;
    }

    // If expired → logout
    if (Date.now() > expiresAt) {
      localStorage.removeItem("admin");
      localStorage.removeItem("expiresAt");
      setIsLoggedIn(null);
    }
  }, 30 * 1000);

  return () => clearInterval(interval);
}, []);


  return (
    <Router>
      <AppContent isLoggedIn={isLoggedIn} handleLogin={handleLogin} />
    </Router>
  );
}

export default App;
